import { BaseRouteService } from 'core/services';

class ReportRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'reports/';
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	update(report, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', report, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	sendReport(sendReportParams) {
		return super.update(this.base + 'send-report', sendReportParams);
	}
}

export default ReportRouteService;
